import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import AnalyticsTracker from './components/AnalyticsTracker';
import MainToolbar from './components/MainToolbar';
import Profile from './containers/Profile';
import Page404 from './containers/Page404';
import TanglaoOsSubmission from './containers/TanglaoOsSubmission';

import './App.css';

function App() {
  const title = 'Franz Noel Tanglao';

  return (
    <Router>
      <div className="app-shell">
        <AnalyticsTracker />
        <MainToolbar title={title} />
        <Switch>
          <Route exact path="/" render={(props) => <Profile {...props} title={title} />} />
          <Route exact path="/tanglao-os" component={TanglaoOsSubmission} />
          <Route exact path="/tanglao-os/privacy" component={TanglaoOsSubmission} />
          <Route exact path="/tanglao-os/user-data-deletion" component={TanglaoOsSubmission} />
          <Route path="*" component={Page404} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
